<template>
    <div class="app-container">
        <el-form ref="form" :model="form" label-width="120px" class="event-form">

            <el-row>
                <el-col :span='12'>
                    <el-form-item label="请选择回滚的版本">
                        <el-select v-model="form.rtag" placeholder="请选择回滚的版本" clearable>
                            <el-option v-for="item in listAll" :key="item" :label="item" :value="item"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span='24'>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">确定</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import services from "../../cicd.services"

    export default {

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            params() {
                return this.$route.params
            },
            parentId() {
                return this.params.id
            }
            
        },

        data() {
            return {
                loading: false,
                form: {
                    
                },
                listAll: []
            };
        },

        mounted() {
            this.request()
        },
        
        methods: {
            // 获取数据
            request() {
                services.rollbackRtag({appId: this.parentId})
                    .then(res => this.listAll = res)
                    .catch(err => this.$message.error(err.message))
            },

            // 设置请求数据
            setRequest() {
                return {
                    pid: this.params.pid,
                    deploy_id: this.params.selfId,
                    rollback: 1,
                    ...this.form,
                }
            },

            // 点击确定
            onSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        const params = this.setRequest()
                        const loading = this.$loading({
                            lock: true,
                            text: "Loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)"
                        })
                        services.deployKill(params)
                            .then(() => services.deployRollback(params))
                            .then(() => services.deployRun(params))
                            .catch(err => this.$message.error(err.message))
                            .finally(() => {
                                loading.close()
                                this.$modal.close()
                            })
                    } else {
                        return false;
                    }
                });
            },

            // 点击取消
            onCancel() {
                this.$modal.close()
            },
        }
    };
</script>

<style lang="scss" scoped>

</style>
